import React, { useEffect, useRef } from 'react';
import { Box } from '@mui/material';

export default function VendorGrowthCard() {
  const chartRef = useRef(null);
  const initialized = useRef(false);

  useEffect(() => {
    if (initialized.current) return;
    initialized.current = true;

    if (chartRef.current && typeof window.mgmtGrowthChart !== 'undefined') {
      window.mgmtGrowthChart.canvas = chartRef.current;
      window.mgmtGrowthChart.ctx = chartRef.current.getContext('2d');
    }
  }, []);

  return (
    <Box className="card" style={{ minHeight: '300px' }}>
      <div className="card-head">
        <h3 className="card-title" id="mgmtGrowthTitle">Vendor Growth</h3>
        <span className="click-tag">Click bars to filter</span>
      </div>
      <div className="chart-wrap" style={{ height: '240px' }}>
        <canvas id="mgmtGrowth" ref={chartRef}></canvas>
      </div>
    </Box>
  );
}
